import React, { useState , useEffect } from 'react';

import VerifiedCustomers from "./verifiedCustomers"
import DashboardSidebar from '../agencyDashboardSidebar';
import { ReactComponent as SendUp } from '../../../_asset/img/send_up.svg';
import { ReactComponent as SearchIcon } from '../../../_asset/img/search-normal.svg';
import NewCustomer from './customerform';
import { useParams, useHistory } from 'react-router-dom';
import { useUser } from '../../../../context/UserContext';
import { useProviderCompany } from '../../../../context/ProviderCompanyContext';
import { getCustomerCompanies } from "../../../../services/staffingService";
import { Link } from 'react-router-dom';

const Customers = () => {

    const { userInfo, userInfoReady } = useUser();
    const { providerCompanyId } = useParams();
    const { providerCompanyData, fetchProviderCompanyData } = useProviderCompany();
    const [customerCompanies, setCustomerCompanies] = useState([]);
    const [filteredCustomerCompanies, setFilteredCustomerCompanies] = useState([]);
    const [areFiltersActive, setAreFiltersActive] = useState(false); // State to track if filters are active

    const [filters, setFilters] = useState({
        searchText: '',
        companyLegalName: null,
        facilityType: null,
        contactPersonName: null,
        email: null,
        hasSLA: false, // This will filter if the company has an SLA
    });

    const [showSideDrawer, setShowSideDrawer] = useState(false);

    useEffect(() => {
        fetchCustomerCompanies();
    }, [providerCompanyId])

    const fetchCustomerCompanies = async () => {
        const resp = await getCustomerCompanies(providerCompanyId);
        setCustomerCompanies([...resp.data.customerCompanies]);
        setFilteredCustomerCompanies([...resp.data.customerCompanies]);
    }
    

    // Function to handle filter changes
        const handleFilterChange = (key, value) => {
            setFilters({ ...filters, [key]: value });
        };

        const getUniqueOptions = (key) => {
            return Array.from(
                new Set(
                    customerCompanies.map((item) => {
                        const keys = key.split('.'); // Support nested keys
                        return keys.reduce((acc, curr) => acc && acc[curr], item); // Access nested properties like contact.contactPersonName
                    })
                )
            ).map((value) => ({
                label: value || 'N/A',
                value: value || 'N/A',
            }));
        };
        
    
        const applyFilters = () => {
            const filtered = customerCompanies.filter((item) => {
                const matchesSearchText =
                    filters.searchText === '' ||
                    item.companyLegalName.toLowerCase().includes(filters.searchText.toLowerCase()) ||
                    item.companyFriendlyName.toLowerCase().includes(filters.searchText.toLowerCase()) ||
                    item.contact.contactPersonName.toLowerCase().includes(filters.searchText.toLowerCase()) ||
                    item.contact.email.toLowerCase().includes(filters.searchText.toLowerCase());
    
                const matchesCompanyLegalName = !filters.companyLegalName || item.companyLegalName === filters.companyLegalName;
                const matchesFacilityType = !filters.facilityType || item.facilityType === filters.facilityType;
                const matchesContactPersonName = !filters.contactPersonName || item.contact.contactPersonName === filters.contactPersonName;
                const matchesEmail = !filters.email || item.contact.email === filters.email;
                const matchesHasSLA = !filters.hasSLA || !!item.serviceAgreementUrl; // Check if SLA exists (serviceAgreementUrl is not empty)
    
                return (
                    matchesSearchText &&
                    matchesCompanyLegalName &&
                    matchesFacilityType &&
                    matchesContactPersonName &&
                    matchesEmail &&
                    matchesHasSLA
                );
            });
    
            setFilteredCustomerCompanies(filtered);
            const activeFilters = checkIfFiltersAreActive();
            setAreFiltersActive(activeFilters); // Update state if filters are active
        };  
        
        const checkIfFiltersAreActive = () => {
            return (
                filters.searchText !== '' ||
                filters.companyLegalName !== null ||
                filters.facilityType !== null ||
                filters.contactPersonName !== null ||
                filters.email !== null ||
                filters.hasSLA !== false
            );
        };
    
        // Function to reset filters
        const resetFilters = () => {
            setFilters({
                searchText: '',
                companyLegalName: null,
                facilityType: null,
                contactPersonName: null,
                email: null,
                hasSLA: false,
            });
            setFilteredCustomerCompanies(customerCompanies); // Reset to original data
            // setSelectedFilters(false);
            setAreFiltersActive(false);
        };

    return (
      <div className="flex h-screen overflow-hidden bg-gray-50 font-inter">
        <DashboardSidebar isOpen={showSideDrawer} setIsOpen={setShowSideDrawer} />
        <main className="flex-1 overflow-y-auto">
          <div className="p-6">

            {/* Page Header */}
            <div className="mb-6 flex items-start justify-between">
              <div>
                <h1 className="text-xl font-semibold text-gray-900">Customers</h1>
                <p className="text-sm text-gray-500">Manage your customer companies</p>
              </div>
              <div className="flex items-center gap-3">
                <a href="/partner-success" target="_blank" rel="noreferrer">
                  <button className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 border border-gray-200 bg-white rounded-lg hover:bg-gray-50 transition-colors">
                    <span className="w-6 h-6 bg-green-100 text-green-700 text-xs font-semibold rounded-full flex items-center justify-center">
                      84
                    </span>
                    Customers Around You
                    <SendUp />
                  </button>
                </a>
                <Link to={`/provider-company/${providerCompanyId}/crm/new`}>
                  <button className="px-4 py-2 text-sm font-semibold text-white rounded-lg hover:opacity-90 transition-opacity" style={{ backgroundColor: 'var(--primary)' }}>
                    + Create New Customer
                  </button>
                </Link>
              </div>
            </div>

            {/* Content: filter sidebar + customer list */}
            <div className="flex gap-6">

              {/* Filter panel */}
              <div className="w-72 flex-shrink-0 bg-white rounded-xl border border-gray-200 p-4 h-fit sticky top-0">
                <h2 className="text-sm font-semibold text-gray-900 mb-4">Filter</h2>
                
                <div className="relative mb-3">
                  <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                    <SearchIcon />
                  </div>
                  <input
                    type="text"
                    className="form-input form-input-with-icon"
                    placeholder="Search customers"
                    value={filters.searchText}
                    onChange={(e) => handleFilterChange("searchText", e.target.value)}
                  />
                </div>
                
                <div className="space-y-2 mb-4">
                  <select className="form-select" value={filters.companyLegalName || ''} onChange={(e) => handleFilterChange("companyLegalName", e.target.value || null)}>
                    <option value="">Company Legal Name</option>
                    {getUniqueOptions("companyLegalName").map((opt, i) => <option key={i} value={opt.value}>{opt.label}</option>)}
                  </select>
                  <select className="form-select" value={filters.facilityType || ''} onChange={(e) => handleFilterChange("facilityType", e.target.value || null)}>
                    <option value="">Facility Type</option>
                    {getUniqueOptions("facilityType").map((opt, i) => <option key={i} value={opt.value}>{opt.label}</option>)}
                  </select>
                  <select className="form-select" value={filters.contactPersonName || ''} onChange={(e) => handleFilterChange("contactPersonName", e.target.value || null)}>
                    <option value="">Primary Contact Person Name</option>
                    {getUniqueOptions("contact.contactPersonName").map((opt, i) => <option key={i} value={opt.value}>{opt.label}</option>)}
                  </select>
                  <select className="form-select" value={filters.email || ''} onChange={(e) => handleFilterChange("email", e.target.value || null)}>
                    <option value="">Primary Contact Email</option>
                    {getUniqueOptions("contact.email").map((opt, i) => <option key={i} value={opt.value}>{opt.label}</option>)}
                  </select>
                </div>

                <div className="mb-5">
                  <div className="flex items-center gap-2">
                    <button
                      type="button"
                      className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2 ${filters.hasSLA ? 'bg-primary' : 'bg-gray-300'}`}
                      onClick={() => handleFilterChange("hasSLA", !filters.hasSLA)}
                      role="switch"
                      aria-checked={filters.hasSLA}
                      style={{ '--tw-ring-color': 'var(--primary)' }}
                    >
                      <span aria-hidden="true" className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${filters.hasSLA ? 'translate-x-5' : 'translate-x-0'}`} />
                    </button>
                    <span className="text-sm text-gray-500">Has SLA</span>
                  </div>
                </div>

                {!areFiltersActive ? (
                  <button className="w-full py-2 text-sm font-semibold text-white rounded-lg hover:opacity-90 transition-opacity" style={{ backgroundColor: 'var(--primary)' }} onClick={applyFilters}>
                    Apply
                  </button>
                ) : (
                  <button className="text-sm text-gray-500 hover:text-gray-900 transition-colors underline cursor-pointer" onClick={resetFilters}>
                    Reset Filters
                  </button>
                )}
              </div>

              {/* Customer list */}
              <div className="flex-1 min-w-0">
                <VerifiedCustomers
                  customerCompanies={customerCompanies}
                  filteredCustomerCompanies={filteredCustomerCompanies}
                  setCustomerCompanies={setCustomerCompanies}
                  setFilteredCustomerCompanies={setFilteredCustomerCompanies}
                  providerCompanyId={providerCompanyId}
                />
              </div>
            </div>

          </div>
        </main>
      </div>
    );
};

export default Customers;